import { Action } from '@ngrx/store';
import { HttpError, LoyaltyProgram, LoyaltyProgramCategory } from '@rd/types';

export enum LoyaltyProgramActionTypes {
  CHANGE_LOYALTY_PROGRAMS_FILTER_CATEGORY = '[Programs] Change Filter Category',
  CHANGE_LOYALTY_PROGRAMS_FILTER_KEYWORD = '[Programs] Change Filter Keyword',
  LOAD_LOYALTY_PROGRAMS = '[Programs] Load LoyaltyPrograms',
  LOAD_LOYALTY_PROGRAMS_SUCCESS = '[Programs] Load LoyaltyPrograms Success',
  LOAD_LOYALTY_PROGRAMS_FAIL = '[Programs] Load LoyaltyPrograms Fail',
  LOAD_SINGLE_LOYALTY_PROGRAM = '[Programs] Load Single LoyaltyProgram',
  LOAD_SINGLE_LOYALTY_PROGRAM_SUCCESS = '[Programs] Load Single LoyaltyProgram Success',
  LOAD_SINGLE_LOYALTY_PROGRAM_FAIL = '[Programs] Load Single LoyaltyProgram Fail',
}

export class ChangeLoyaltyProgramsFilterCategory implements Action {
  readonly type =
    LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_CATEGORY;

  constructor(public payload: LoyaltyProgramCategory | 'all') {}
}

export class ChangeLoyaltyProgramsFilterKeyword implements Action {
  readonly type =
    LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_KEYWORD;

  constructor(public payload: string) {}
}

export class LoadLoyaltyPrograms implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS;
}

export class LoadLoyaltyProgramsSuccess implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_SUCCESS;

  constructor(public payload: LoyaltyProgram[]) {}
}

export class LoadLoyaltyProgramsFail implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_FAIL;

  constructor(public payload: HttpError) {}
}

export class LoadSingleLoyaltyProgram implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_SINGLE_LOYALTY_PROGRAM;

  constructor(public payload: string) {}
}

export class LoadSingleLoyaltyProgramSuccess implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_SINGLE_LOYALTY_PROGRAM_SUCCESS;

  constructor(public payload: LoyaltyProgram) {}
}

export class LoadSingleLoyaltyProgramFail implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_SINGLE_LOYALTY_PROGRAM_FAIL;

  constructor(public payload: HttpError) {}
}

export type LoyaltyProgramActions =
  | ChangeLoyaltyProgramsFilterCategory
  | ChangeLoyaltyProgramsFilterKeyword
  | LoadLoyaltyPrograms
  | LoadLoyaltyProgramsSuccess
  | LoadLoyaltyProgramsFail
  | LoadSingleLoyaltyProgram
  | LoadSingleLoyaltyProgramSuccess
  | LoadSingleLoyaltyProgramFail;
